import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorService } from "../../services/api/vendor.service";
import { VendorActions } from "../actions/vendor.actions";

@Injectable()
export class VendorEffects {
	countRequested = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.getCount),
			switchMap(() => {
				return this.vendorService.count().pipe(
					map((count) =>
						VendorActions.getCountSuccess({
							vendorCountState: { count, loading: false }
						})
					),
					catchError((error) => of(VendorActions.getCountFailed({ error })))
				);
			})
		)
	);

	constructor(private actions: Actions, private vendorService: VendorService) {}
}
